import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Dashboard from './components/Dashboard/Dashboard';

ReactDOM.render(<Dashboard />, document.getElementById('root'));
